<template>
  <Navigation/>
  <router-view/>
  <Footer/>
</template>

<script>
import Navigation from '@/components/NavComponent.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Navigation,
    Footer
  },
  data() {
    return {
      // Define any data properties here if needed
    };
  },
}
</script>


<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: $text-light;
}


</style>
